import { v4 as uuidv4 } from 'uuid';

export default function uuid(): string {
  return uuidv4();
}

/**
 * Generates a short UUID by taking first 8 characters of a full UUID
 * @returns A short UUID string (8 characters)
 */
export function shortUuid(): string {
  return uuidv4().substring(0, 8);
}
